'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @returns String containing the current senna version
 */

var version = '2.7.0';

exports.default = version;